import BaseService from "../BaseService";
import _ from "lodash";

class PointService extends BaseService {

    get = async (code) => {
        var data = await this._api.get(`/store/point`);
        return data;
    };



}
export default PointService;
